// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const LineNotes: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M38.3 19.3c-.1-.6-.6-1-1.2-1-.7 0-1.2.5-1.2 1.2v21.6h-33v-33h21.8c.6-.1 1-.6 1-1.2 0-.7-.5-1.2-1.2-1.2H2.6C1.5 5.8.5 6.8.5 8.1v33.4c.1 1.2 1.1 2.2 2.3 2.2h33.4c1.2-.1 2.2-1.1 2.2-2.3V19.6l-.1-.3z"/><path d="M43 6.7l-5.3-5.3-.1-.1c-.9-.7-2.2-.7-3 .1L15.4 20.7l-4 12.2 12.5-3.7 15.7-15.8L43 10l.1-.1c.8-1 .8-2.4-.1-3.2zm-9.6-.6l2.8-2.8 5 5-2.8 2.8-5-5zM15.1 29.3l2.4-7.3L31.7 7.8l5 5L22.6 27l-7.5 2.3z"/></svg>;
};

export default React.memo(LineNotes);
